// Generated file - do not change manually!

/**
 * Different types of Tab layouts.
 */
export enum TabLayout {
  /**
   * Inline type, the tab <code>main text</code> and <code>additionalText</code> are displayed horizotally.
   */
  Inline = 'Inline',

  /**
   * Standard type, the tab <code>main text</code> and <code>additionalText</code> are displayed vertically.
   */
  Standard = 'Standard'
}
